import React from 'react';
import AppointmentForm from './AppointmentForm';

function App() {
  return (
    // <div className="App"> silinebilir, sarmalayıcıya artık css'te gerek yok
    <AppointmentForm />
  );
}

export default App;